import { cn } from '@latitude/token-utils';
import type { JSX } from 'react';

import type { SVGProps } from '../types';

export const WarningIllustration = (props: SVGProps): JSX.Element => {
  const { title = 'WarningIllustration', className, ...restProps } = props;

  return (
    <svg
      className={cn('text-color-ref-primary-primary-50', className)}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 230 177"
      {...restProps}
    >
      <title>{title}</title>
      <path
        d="M58.1422 119.116C65.1421 113.708 69.6001 107.749 68.0996 105.807C66.599 103.865 59.708 106.675 52.7081 112.083C45.7082 117.491 41.2501 123.449 42.7507 125.392C44.2513 127.334 51.1423 124.524 58.1422 119.116Z"
        fill="none"
        stroke="white"
        strokeWidth="1.6"
        strokeMiterlimit="10"
      />
      <path
        d="M7.75048 90.9696C12.0309 90.9696 15.501 87.4996 15.501 83.2192C15.501 78.9387 12.0309 75.4688 7.75048 75.4688C3.47001 75.4688 0 78.9387 0 83.2192C0 87.4996 3.47001 90.9696 7.75048 90.9696Z"
        fill="currentColor"
      />
      <path
        d="M219.018 105.191C225.083 105.191 230 100.274 230 94.209C230 88.1436 225.083 83.2266 219.018 83.2266C212.952 83.2266 208.035 88.1436 208.035 94.209C208.035 100.274 212.952 105.191 219.018 105.191Z"
        fill="currentColor"
      />
      <path
        d="M35.7918 52.9858C42.5707 52.9858 48.0661 47.4905 48.0661 40.7117C48.0661 33.9328 42.5707 28.4375 35.7918 28.4375C29.0129 28.4375 23.5176 33.9328 23.5176 40.7117C23.5176 47.4905 29.0129 52.9858 35.7918 52.9858Z"
        fill="currentColor"
      />
      <path
        d="M45.7217 32.8238C45.7217 32.8238 55.0563 28.8582 55.1785 30.2616C55.6144 35.269 39.9061 48.2449 22.4064 51.1898C4.90673 54.1348 24.0543 44.0507 24.0543 44.0507"
        fill="none"
        stroke="white"
        strokeWidth="1.6"
        strokeMiterlimit="10"
      />
      <path
        d="M48.2674 168.504C54.6587 168.504 59.8399 163.323 59.8399 156.932C59.8399 150.541 54.6587 145.359 48.2674 145.359C41.876 145.359 36.6948 150.541 36.6948 156.932C36.6948 163.323 41.876 168.504 48.2674 168.504Z"
        fill="none"
        stroke="white"
        strokeWidth="1.6"
        strokeMiterlimit="10"
      />
      <path
        d="M149.524 152.027C153.555 152.027 156.822 148.759 156.822 144.728C156.822 140.697 153.555 137.43 149.524 137.43C145.493 137.43 142.225 140.697 142.225 144.728C142.225 148.759 145.493 152.027 149.524 152.027Z"
        fill="none"
        stroke="white"
        strokeWidth="1.6"
        strokeMiterlimit="10"
      />
      <path
        d="M151.232 124.307C153.083 116.4 141.584 106.946 125.548 103.191C109.512 99.4354 95.0108 102.801 93.1592 110.707C91.3076 118.614 102.807 128.068 118.843 131.823C134.879 135.578 149.38 132.213 151.232 124.307Z"
        fill="none"
        stroke="white"
        strokeWidth="1.6"
        strokeMiterlimit="10"
      />
      <path
        d="M24.0432 176.966C23.9953 175.829 23.9688 174.686 23.9688 173.538C23.9688 129.247 59.8719 93.3438 104.163 93.3438C142.916 93.3438 175.252 120.832 182.731 157.378C183.8 162.598 184.363 168.004 184.363 173.538"
        fill="none"
        stroke="white"
        strokeWidth="1.6"
        strokeMiterlimit="10"
      />
      <path
        d="M227.321 45.3583C227.321 45.3583 227.321 36.9221 218.305 38.4531C209.29 39.9893 206.414 40.5634 206.222 36.3427C206.031 32.122 202.384 27.9066 193.948 30.3997C185.512 32.8928 176.688 36.3427 174.386 34.429C172.084 32.51 170.548 32.3187 172.275 26.3756C174.003 20.4326 164.413 17.1687 157.125 20.4326C149.837 23.6911 127.208 37.5015 117.235 45.1722C117.235 45.1722 225.265 45.3636 227.321 45.3636V45.3583Z"
        fill="none"
        stroke="white"
        strokeWidth="1.6"
        strokeMiterlimit="10"
      />
      <path
        d="M65.0552 66.1762L107.348 1.7861C108.911 -0.595368 112.403 -0.595368 113.966 1.7861L156.259 66.1762C157.987 68.8075 156.099 72.3107 152.947 72.3107H68.3564C65.2041 72.3107 63.3169 68.8129 65.0446 66.1762H65.0552Z"
        fill="white"
      />
      <path
        d="M110.66 61.3751C112.653 61.3751 114.269 59.7591 114.269 57.7657C114.269 55.7722 112.653 54.1562 110.66 54.1562C108.666 54.1562 107.05 55.7722 107.05 57.7657C107.05 59.7591 108.666 61.3751 110.66 61.3751Z"
        fill="black"
        stroke="black"
        strokeWidth="1.6"
        strokeMiterlimit="10"
      />
      <path
        d="M110.899 22.5938H110.894C109.209 22.5938 107.842 23.9598 107.842 25.645V43.8091C107.842 45.4942 109.209 46.8603 110.894 46.8603H110.899C112.584 46.8603 113.95 45.4942 113.95 43.8091V25.645C113.95 23.9598 112.584 22.5938 110.899 22.5938Z"
        fill="black"
        stroke="black"
        strokeWidth="1.6"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

WarningIllustration.displayName = 'WarningIllustration';
